import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import anime from "animejs";
import _ from "lodash";
import { Slider, LoadingSlider } from "../components";

export default class SliderWithLoading extends Component {
  static propTypes = {
    t: PropTypes.func,
    items: PropTypes.array,
    position: PropTypes.string,
    loadingHeight: PropTypes.number,
    loadingColor: PropTypes.string,
    duration: PropTypes.number,
    isRenderTitle: PropTypes.bool,
  };
  static defaultProps = {
    items: [],
    position: "bottom",
    loadingHeight: 5,
    loadingColor: "lightgrey",
    duration: 5000,
    isRenderTitle: false,
    t: () => {},
  };
  state = {
    onIndex: 0,
  };
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
    this.barRef = React.createRef();
    this.titleRef = React.createRef();
  }
  handleLoadingComplete = () => {
    if (this.sliderRef && this.sliderRef.current)
      this.sliderRef.current.slickNext();
  };
  handleBeforeChangeSlider = (current, next) => {
    if (current < next) {
      this.sliderRef.current.slickNext();
    } else if (current > next) {
      this.sliderRef.current.slickPrev();
    }
    this.barRef.current.getAnimate().restart();

    // anime({
    //   targets: ".content-title",
    //   easing: "linear",
    //   width: [500, 300],
    //   scale: [1.1, 1],
    //   opacity: [0, 1],
    //   duration: 2000,
    //   delay: 1500,
    // });

    // anime({
    //   targets: ".content-title-detail",
    //   easing: "linear",
    //   scale: [1.8, 1],
    //   opacity: [0.2, 1],
    //   duration: 2000,
    //   delay: 2000,
    // });
  };
  renderTitle = () => {
    const { t, items } = this.props;
    const { onIndex } = this.state;
    const item = items[onIndex];
    console.log("renderTitle", this.props);
    return (
      <div
        className={`content-title ${_.get(item, "position")}`}
        ref={this.titleRef}
      >
        <div
          className={`content-title-detail ${_.get(item, "position")}`}
          style={{ alignItems: "flex-start" }}
        >
          <h1>{t(_.get(item, "title"))}</h1>
          <h1>{t(_.get(item, "subTitle"))}</h1>
        </div>
      </div>
    );
  };
  render() {
    const {
      t,
      items,
      position,
      loadingHeight,
      loadingColor,
      duration,
      isRenderTitle,
    } = this.props;
    return (
      <Container>
        <Slider
          sliderRef={this.sliderRef}
          settings={{
            dots: false,
            autoplay: false,
            beforeChange: this.handleBeforeChangeSlider,
          }}
          items={items}
          onClick={(a, b, c, d) =>
            console.log("handleBeforeChangeSlider", a, b, c, d)
          }
          uiRenderer={(item) => {
            return (
              <div
                className="img-background"
                style={{
                  backgroundImage: `url('${_.get(item, "image")}')`,
                }}
              >
                {/* {isRenderTitle && (
                  <div
                    className={`content-title ${_.get(item, "position")}`}
                    ref={this.titleRef}
                  >
                    <div
                      className={`content-title-detail ${_.get(
                        item,
                        "position"
                      )}`}
                      style={{ alignItems: "center" }}
                      // style={{ alignItems: "flex-start" }}
                    >
                      <h1>
                        <p style={{ marginBottom: "15px" }}>
                          {t(_.get(item, "title"))}
                        </p>
                        <p>{t(_.get(item, "subTitle"))}</p>
                      </h1>
                    </div>
                  </div>
                )} */}
              </div>
            );
          }}
        />
        {/* {isRenderTitle && this.renderTitle()} */}
        <LoadingContainer position={position}>
          <LoadingSlider
            ref={this.barRef}
            height={loadingHeight}
            color={loadingColor}
            duration={duration}
            onComplete={this.handleLoadingComplete}
          />
        </LoadingContainer>
      </Container>
    );
  }
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const LoadingContainer = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  ${(props) => {
    if (props.position === "top") {
      return `
        top: 0;
      `;
    } else if (props.position === "bottom") {
      return `
        bottom: 0;
      `;
    }
  }};
`;



// WEBPACK FOOTER //
// ./src/components/SliderWithLoading.js